import { Button } from "@/components/ui/button";
import {
    DropdownMenu,
    DropdownMenuContent,
    DropdownMenuItem,
    DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { MoreHorizontal } from "lucide-react";
import { useNavigate } from 'react-router-dom';

export function ProjectListItem({ 
  project,
  className,
  onProjectUpdate,
  columnConfig = {
    name: true,
    key: true,
    organization: true,
    taskCount: true,
    role: true,
    actions: true
  },
  ...props 
}) {
  const navigate = useNavigate();

  const handleRowClick = (e) => {
    if (e.target.closest('.project-action')) {
      e.stopPropagation();
      return;
    }
    navigate(`/${project.organizationSlug}/plan/${project.key}`);
  };

  // Build grid columns dynamically based on config
  const getGridTemplateColumns = () => {
    const columns = [];
    if (columnConfig.name) columns.push('1fr');
    if (columnConfig.key) columns.push('100px');
    if (columnConfig.organization) columns.push('200px');
    if (columnConfig.taskCount) columns.push('100px');
    if (columnConfig.role) columns.push('120px');
    if (columnConfig.actions) columns.push('48px');
    return columns.join(' ');
  };

  return (
    <div
      onClick={handleRowClick}
      className={`grid gap-4 items-center p-3 rounded-lg dark:bg-muted/20 dark:hover:bg-muted/60 bg-muted/60 hover:bg-muted/90 h-16 
        cursor-pointer transition-colors ${className}`}
      style={{ gridTemplateColumns: getGridTemplateColumns() }}
      {...props}
    >
      {columnConfig.name && (
        <div className="text-sm font-medium">{project.name}</div>
      )}

      {columnConfig.key && (
        <div className="text-sm text-muted-foreground">{project.key}</div>
      )}

      {columnConfig.organization && (
        <div className="text-sm text-muted-foreground">{project.organizationName}</div>
      )}

      {columnConfig.taskCount && (
        <div className="text-sm text-muted-foreground">{project.taskCount} tasks</div>
      )}

      {columnConfig.role && (
        <div className="text-sm">{project.role || 'Member'}</div>
      )}

      {columnConfig.actions && (
        <div className="project-action">
          <DropdownMenu>
            <DropdownMenuTrigger asChild>
              <Button variant="outline" size="icon" className="h-8 w-8">
                <MoreHorizontal className="h-4 w-4" />
                <span className="sr-only">Open menu</span>
              </Button>
            </DropdownMenuTrigger>
            <DropdownMenuContent align="end">
              <DropdownMenuItem>Settings</DropdownMenuItem>
              <DropdownMenuItem>Share</DropdownMenuItem>
              <DropdownMenuItem className="text-destructive">Delete</DropdownMenuItem>
            </DropdownMenuContent>
          </DropdownMenu>
        </div>
      )}
    </div>
  );
} 